import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { handleNavigation, handleMenuClick } from '../utils/navigationsHandlers';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  // Fecha o menu automaticamente sempre que a rota mudar
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  return (
    <header className="header-mobile-nova">
      <div className="header-container-nova">
        <img 
          src="/assets/logo.svg" 
          onClick={() => handleNavigation(navigate, '/')} 
          alt="Logo" 
          className="logo-img" 
          style={{ cursor: 'pointer' }}
        />
        
        {/* === MUDANÇA AQUI: Transformamos o botão em uma área relativa === */}
        <div 
          className="menu-icon-nova" 
          onClick={() => setIsOpen(!isOpen)}
          style={{ position: 'relative' }} /* Trava a caixinha exatamente aqui abaixo do ícone */
        >
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#0A473C" strokeWidth="2">
            <path d="M4 6h16M4 12h16M4 18h16"/>
          </svg>

          {/* === A caixinha do menu agora foi movida para DENTRO do botão === */}
          {isOpen && (
            <div 
              className="menu-dropdown-nova" 
              id="menu-dropdown"
              style={{ 
                position: 'absolute',
                top: '40px', /* Distância perfeita para brotar abaixo das 3 barrinhas */
                right: '0',  /* Gruda perfeitamente na quina direita do ícone hambúrguer */
                left: 'auto'
              }}
              onClick={(e) => e.stopPropagation()} /* Evita que o menu feche ao clicar nas opções */
            >
              <a onClick={() => handleMenuClick(navigate, '/')}>Início</a>
              <a onClick={() => handleMenuClick(navigate, '/quem-somos')}>Quem somos</a>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;